import React from "react";
import { useHooks } from "./hooks";
import { PricingPluginProps } from "./interfaces";

export const PricingPlugin = React.memo((props: PricingPluginProps) => {
  const { map } = useHooks(props);

  if (map) {
    return <></>;
  }

  return null;
});
